import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../hooks';
import { sendCourseCreditReminderNotificationToAdmin } from '../../store/V2/CoursesSlice';

const ActionsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const triggerType = searchParams.get('tt');
    const courseId = searchParams.get('cid');
    const whatsappLink = searchParams.get('wal');

    if (triggerType === 'emailCreditsReminder' && courseId) {
      dispatch(
        sendCourseCreditReminderNotificationToAdmin({
          courseId,
          sourceName: 'Email',
        })
      );

      searchParams.delete('tt');
      searchParams.delete('cid');

      setSearchParams(searchParams);

      navigate(`${process.env.PUBLIC_URL}/portal/courses/${courseId}`, {
        replace: true,
      });
    } else if (
      triggerType === 'whatsappCreditsReminder' &&
      courseId &&
      whatsappLink
    ) {
      dispatch(
        sendCourseCreditReminderNotificationToAdmin({
          courseId,
          sourceName: 'Whats app',
        })
      );

      searchParams.delete('tt');
      searchParams.delete('cid');
      searchParams.delete('wal');

      setSearchParams(searchParams);

      window.location.href = whatsappLink;
    }
  }, []);

  return null;
};

export default ActionsPage;
